import Vue from 'vue'
import axios from 'axios'
import api from '@/api'
import loader from '@/loader'
import Noty from 'noty'

import {
    SET_BOT_LINK,
    SET_LOADING,
    SET_STATUS,
    SET_ORDER_ID,
    SET_PAYMENT_LINK,
    SET_SYSTEM_POPUP
} from '@/store/mutations.type'
import {
    MAKE_ORDER,
    MAKE_BOOKING,
    CALL_WAITER,
    CHECK_IIKO,
    SET_GLOBAL_ERROR,
    SET_EXPIRED_PRODUCTS
} from '@/store/actions.type'

const state = {
    order_id: null,
    payment_link: ''
}

const getters = {}

export const actions = {
    [CALL_WAITER](context, { comment }) {
        context.commit(SET_LOADING, { process: CALL_WAITER, loading: true })

        return axios({
            method: 'POST',
            url: api.webview.callWaiter.url(),
            data: {
                comment,
            }
        }).then(response => {
            // context.commit(SET_STATUS, { process: CALL_WAITER, status: true })
            return response.data

        }).catch(error => {
            if (error.response != undefined) {
                context.commit(SET_SYSTEM_POPUP, { status: true, text: error.response.data.message });
                context.commit(SET_EXPIRED_PRODUCTS, error.response.data.expired_products);
            }
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })

        }).finally(() => {
            context.commit(SET_LOADING, { process: CALL_WAITER, loading: false })
            // context.commit(SET_STATUS, { process: CALL_WAITER, status: false });
        })
    },

    [MAKE_ORDER](context, {
        address,
        flat,
        cashback,
        porch,
        email,
        floor,
        domofon,
        comment,
        changing,
        deliveryService,
        payment,
        paymentCustom,
        name,
        phone,
        fullName,
        localAddress,
        fullAddress,
        recipientPhone,
        formCustomFields,
        qty_devices,
        isDgsnWidgetRoot,
        deliveryMethodCalcId,
        delivery_method_pvz_id,
        delivery_method_pvz_data,
        city_name,
        dadata_street,
        tips_amount,
    }) {

        // if (context.getters.loading[MAKE_ORDER] === true) {
        //     return
        // }

        context.commit(SET_LOADING, { process: MAKE_ORDER, loading: true })

        let newAddress = null;

        const deliveryTimeObject = {
            ...JSON.parse(JSON.stringify(context.getters.deliveryTimeObject ))
        }

        deliveryTimeObject.time.asap = false


        return axios({
            method: 'POST',
            url: api.order.createOrder.url(),
            data: {
                time: deliveryTimeObject,
                flat: flat !== undefined ? flat : null,
                address: address !== undefined ? (newAddress === null ? address : newAddress) : null,
                porch: porch !== undefined ? porch : null,
                floor: floor !== undefined ? floor : null,
                domofon: domofon !== undefined ? domofon : null,
                // comment: comment !== undefined ? comment : null,
                city_name: city_name !== undefined ? city_name : null,
                dadata_street: dadata_street !== undefined ? dadata_street : null,
                changing: changing !== undefined ? changing : null,
                delivery_service_id: deliveryService !== undefined ? deliveryService.id : null,
                delivery_service_type_id: deliveryService !== undefined ? deliveryService.type : null,
                qty_devices: qty_devices !== undefined ? qty_devices : null,
                payment: payment !== undefined ? payment : null,
                paymentCustom: paymentCustom !== undefined ? paymentCustom : null,
                name: name !== undefined ? name : null,
                delivery_type: context.getters.outletSettings.delivery_type !== undefined ? context.getters.outletSettings.delivery_type : null,
                cashback: cashback !== undefined ? cashback : null,
                phone: phone !== undefined ? phone : null,
                email: email !== undefined ? email : null,
                delivery_method_calc_id: deliveryMethodCalcId ? deliveryMethodCalcId : null,
                delivery_method_pvz_id: delivery_method_pvz_id ? delivery_method_pvz_id : null,
                delivery_method_pvz_data: delivery_method_pvz_data ? delivery_method_pvz_data : null,
                // basket_comment: context.getters.cookComment !== undefined && !context.getters.contactlessMode ? context.getters.cookComment : null,
                comment: comment !== undefined ? comment : null,
                basket_comment: context.getters.cookComment !== undefined ? context.getters.cookComment : null,
                fullName: fullName !== undefined ? fullName : null,
                localAddress: localAddress !== undefined ? localAddress : null,
                fullAddress: fullAddress !== undefined ? fullAddress : null,
                recipientPhone: recipientPhone !== undefined ? recipientPhone : null,
                delivery_time_mode: context.getters.deliveryTimeMode !== undefined ? context.getters.deliveryTimeMode : null,
                promocode: context.getters.promocode !== undefined ? context.getters.promocode : null,
                formCustomFields: formCustomFields !== undefined ? formCustomFields : null,
                isDgsnWidgetRoot: isDgsnWidgetRoot,
                tips_amount: tips_amount,
            }
        }).then(response => {

            if (response.data.bot_link) {
                context.commit(SET_BOT_LINK, response.data.bot_link)
            }

            context.commit(SET_STATUS, { process: MAKE_ORDER, status: true })

            if ((payment === 1 || response.data.payment_data !== undefined) && context.getters.totalPrice !== 0) {
                if (response.data.payment_method === 'GET') {
                    if (loader.check_iiko === 1) {
                        context.commit(SET_ORDER_ID, response.data.order_id)
                        context.commit(SET_PAYMENT_LINK, response.data.payment_link)
                        return true
                    } else {
                        window.location = response.data.payment_link
                    }
                }
                if (response.data.payment_method === 'POST') {

                    // PayAnyWay
                    if (response.data.payment_provider_id === 1) {
                        let form = document.createElement('form')
                        form.method = 'POST'
                        form.action = response.data.payment_link
                        for (name in response.data.payment_data) {
                            let el = document.createElement('input')
                            el.type = 'hidden'
                            el.value = response.data.payment_data[name]
                            el.name = name
                            form.appendChild(el)
                        }
                        document.body.appendChild(form)
                        form.submit()
                    }

                    // CloudPayments
                    if (response.data.payment_provider_id === 3) {
                        // нормализация значения стоимости
                        const normalizeAmount = srcPrice => +srcPrice.toFixed(2)

                        // размер итоговой скидки
                        const orderOriginalAmount = context.getters.totalOnlyProductsNoDiscount
                        const orderDiscountedAmount = context.getters.sumProducts
                        const orderDiscountValue = normalizeAmount(orderOriginalAmount - orderDiscountedAmount)

                        // скидка, применённая "к отдельным товарам/категориям"
                        let productLevelDiscountValue = 0

                        if (orderDiscountValue) {
                            for (const selectedProduct of context.getters.selectedProducts) {
                                const originalAmount = selectedProduct.originalFullPrice
                                const discountedAmount = selectedProduct.fullPrice
                                const productCount = selectedProduct.count
                                productLevelDiscountValue += normalizeAmount((originalAmount - discountedAmount) * productCount)
                            }
                        }

                        // скидка, применённая "на весь заказ", равномерно по всем товарам
                        const orderLevelSharePercent = (orderDiscountedAmount / (normalizeAmount(orderOriginalAmount - productLevelDiscountValue) / 100))

                        // фактический размер предоставленной скидки (накопительная)
                        let factOrderDiscountValue = 0

                        // расчёт скидки для товарной позиции
                        const getOrderItemDiscountedPrice = (price, count, discount) => {
                            const orderItemAmount = discount
                                ? (price * discount / 100)
                                : (price)

                            return normalizeAmount(orderItemAmount)
                        }

                        // Товары из корзины
                        let items = [];

                        context.getters.selectedProducts.forEach(product => {
                            // информация ФНС
                            const fnsInfo = {
                                "vat": response.data.payment_data.fns_info.vat, // НДС
                                "method": product.fns_info.method, // тег-1214 признак способа расчета - признак способа расчета
                                // если не указано в настройках товара, то передаём как 1 (товар) https://developers.cloudkassir.ru/#object
                                "object": (product.fns_info.object === null) ? 1 : product.fns_info.object, // тег-1212 признак предмета расчета - признак предмета товара, работы, услуги, платежа, выплаты, иного предмета расчета
                            }

                            // размер итоговой скидки на товар и модификаторы
                            const productOriginalAmount = product.originalFullPrice
                            const productDiscountedAmount = product.fullPrice
                            const productSharePercent = (productDiscountedAmount / (productOriginalAmount / 100))

                            // расчёт цены со скидками на конкретный товар и на весь заказ
                            let productItemDiscountedPrice = 0

                            if (orderDiscountedAmount > 0) { // если сумма скидки не превышает стоимость товаров
                                productItemDiscountedPrice = getOrderItemDiscountedPrice(product.price, product.count, productSharePercent)
                                productItemDiscountedPrice = getOrderItemDiscountedPrice(productItemDiscountedPrice, product.count, orderLevelSharePercent)
                                factOrderDiscountValue += normalizeAmount(productItemDiscountedPrice * product.count)
                            }

                            // добавление товара
                            const productItem = {
                                ...fnsInfo,
                                "label": product.name, //наименование товара
                                "price": productItemDiscountedPrice, //цена
                                "quantity": product.count, //количество
                                "amount": normalizeAmount(productItemDiscountedPrice * product.count), //сумма
                                //"measurementUnit": product.qty_unit //единица измерения
                            }

                            items.push(productItem)

                            // добавление модификаторов товара
                            if (Array.isArray(product.modifiers)) {
                                product.modifiers.forEach(modifier => {
                                    // передавать только выбранные модификаторы
                                    if (!modifier.selected) {
                                        return
                                    }

                                    // расчёт цены со скидками на конкретный товар и на весь заказ
                                    const modifierQuantity = (product.count * (modifier.is_radio_type ? 1 : modifier.count)) // count есть только у объектов, где is_radio_type === 0, в противном случае count = 1 при условии, что модификатор selected
                                    let modifierItemDiscountedPrice = 0

                                    if (orderDiscountedAmount > 0) { // если сумма скидки не превышает стоимость товаров
                                        modifierItemDiscountedPrice = getOrderItemDiscountedPrice(modifier.price, modifierQuantity, productSharePercent)
                                        modifierItemDiscountedPrice = getOrderItemDiscountedPrice(modifierItemDiscountedPrice, product.count, orderLevelSharePercent)
                                        factOrderDiscountValue += normalizeAmount(modifierItemDiscountedPrice * modifierQuantity)
                                    }

                                    const modifierItem = {
                                        ...fnsInfo,
                                        "label": modifier.name, // наименование
                                        "price": modifierItemDiscountedPrice, // цена
                                        "quantity": modifierQuantity, // количество
                                        "amount": normalizeAmount(modifierItemDiscountedPrice * modifierQuantity), // сумма
                                    }

                                    items.push(modifierItem)
                                })
                            }
                        })

                        // исключение погрешности, возникающей при применении скидок
                        const amountDeviation = normalizeAmount(factOrderDiscountValue - orderDiscountedAmount)
                        const productsCopy = JSON.parse(JSON.stringify(items))
                        const productsCopySortedByPrice = productsCopy.sort((a, b) => (b.amount) - (a.amount))
                        let sameAmountProduct = null // товар, количество которого кратно погрешности
                        let nearAmountProduct = null // товар, количество которого близко к погрешности
                        let bestAmountDifference = Number.MAX_SAFE_INTEGER // лучшая разница между количеством и погрешностью

                        // поиск подходящего продукта для списания погрешности (отсортированы по убыванию стоимости)
                        if (amountDeviation && amountDeviation > 0) {
                            for (const productItemCopy of productsCopySortedByPrice) {
                                // поиск товара, количество которого кратно погрешности
                                let normalizedAmountDeviation = amountDeviation * 100
                                const canBeDivided = (normalizedAmountDeviation % +(productItemCopy.quantity) === 0)
                                const isEnoughAmount = (+(productItemCopy.amount) > +(amountDeviation))
                                if (canBeDivided && isEnoughAmount) {
                                    sameAmountProduct = productItemCopy
                                    break
                                }
                                // поиск товара, количество которого близко к погрешности
                                let amountDifference = 0
                                while (normalizedAmountDeviation % +(productItemCopy.quantity) !== 0) {
                                    normalizedAmountDeviation++
                                    amountDifference++
                                }
                                if (amountDifference < bestAmountDifference) {
                                    nearAmountProduct = productItemCopy
                                    bestAmountDifference = amountDifference
                                }
                            }
                        }

                        // модификатор итоговой стоимости корзины
                        let orderAmountDiscountModifier = 0

                        // если разница отрицательная, то просто устанавливаем модификатор итоговой цены
                        if (amountDeviation && amountDeviation < 0) {
                            orderAmountDiscountModifier = normalizeAmount(+(amountDeviation))
                        }

                        // подмена продукта в исходном списке
                        if (sameAmountProduct || nearAmountProduct) {
                            for (const productItem of items) {
                                // если есть товар, количество которого кратно погрешности
                                if (sameAmountProduct && JSON.stringify(productItem) === JSON.stringify(sameAmountProduct)) {
                                    productItem.price -= normalizeAmount(+(amountDeviation) / +(productItem.quantity))
                                    productItem.amount -= normalizeAmount(+(amountDeviation))
                                    // orderAmountDiscountModifier = normalizeAmount(+(amountDeviation))
                                    break
                                }
                                // если есть товар, количество которого близко к погрешности
                                if (!sameAmountProduct && nearAmountProduct && JSON.stringify(productItem) === JSON.stringify(nearAmountProduct)) {
                                    const adjustedAmountDeviation = normalizeAmount((amountDeviation * 100 + bestAmountDifference) / 100)
                                    productItem.price -= normalizeAmount(+(adjustedAmountDeviation) / +(productItem.quantity))
                                    productItem.amount -= normalizeAmount(+(adjustedAmountDeviation))
                                    orderAmountDiscountModifier = normalizeAmount(bestAmountDifference / 100)
                                    break
                                }
                            }
                        }

                        // Доставка
                        if (context.getters.deliveryPrice > 0) {
                            items.push({
                                "label": "Доставка", //наименование товара
                                "price": context.getters.deliveryPrice, //цена
                                "amount": (context.getters.deliveryPrice).toFixed(2), //сумма
                                "quantity": 1, //количество
                                "vat": response.data.payment_data.fns_info.vat, // НДС
                                "method": 1, // тег-1214 признак способа расчета - признак способа расчета
                                "object": 4, // тег-1212 признак предмета расчета - признак предмета товара, работы, услуги, платежа, выплаты, иного предмета расчета
                            });
                        }

                        // Сервисный сбор
                        if (context.getters.shopMode === 0) {
                            if (context.getters.outlet.data.service_fee.is_active === 1 && context.getters.serviceFeePrice > 0) {
                                items.push({
                                    "label": context.getters.outlet.data.service_fee.name, //наименование товара
                                    "price": context.getters.serviceFeePrice, //цена
                                    "amount": (context.getters.serviceFeePrice).toFixed(2), //сумма
                                    "quantity": 1, //количество
                                    "vat": response.data.payment_data.fns_info.vat, // НДС
                                    "method": 1, // тег-1214 признак способа расчета - признак способа расчета
                                    "object": 4, // тег-1212 признак предмета расчета - признак предмета товара, работы, услуги, платежа, выплаты, иного предмета расчета
                                });
                            }
                        } else {
                            if (context.getters.outlet.outlet.service_fee.is_active === 1 && context.getters.serviceFeePrice > 0) {
                                items.push({
                                    "label": context.getters.outlet.outlet.service_fee.name, //наименование товара
                                    "price": context.getters.serviceFeePrice, //цена
                                    "amount": (context.getters.serviceFeePrice).toFixed(2), //сумма
                                    "quantity": 1, //количество
                                    "vat": response.data.payment_data.fns_info.vat, // НДС
                                    "method": 1, // тег-1214 признак способа расчета - признак способа расчета
                                    "object": 4, // тег-1212 признак предмета расчета - признак предмета товара, работы, услуги, платежа, выплаты, иного предмета расчета
                                });
                            }
                        }

                        let receipt = {
                            "Items": items,
                            "amounts": {
                                "electronic": normalizeAmount(context.getters.totalPrice - Math.abs(orderAmountDiscountModifier)), // Сумма оплаты электронными деньгами
                            }
                        }

                        /*new cp.CloudPayments().auth({
                            publicId: response.data.payment_data.publicId,
                            description: response.data.payment_data.description,
                            amount: response.data.payment_data.amount,
                            currency: response.data.payment_data.currency,
                            invoiceId: response.data.payment_data.invoiceId,
                            accountId: response.data.payment_data.accountId,
                            skin: response.data.payment_data.skin,
                            data: {
                                "CloudPayments": {
                                    "CustomerReceipt": receipt, //онлайн-чек
                                }
                            }
                        },
                        function(options) { // success
                            context.commit(SET_STATUS, { process: MAKE_ORDER, status: true })
                            context.commit(SET_LOADING, { process: MAKE_ORDER, loading: true })
                            loader.router.push({ name: 'finish', params: { token: context.getters.token } })
                        },
                        function(reason, options) { // fail
                            context.commit(SET_STATUS, { process: MAKE_ORDER, status: false })
                            context.commit(SET_LOADING, { process: MAKE_ORDER, loading: false })
                            console.log(reason);
                        })*/
                        var widget = new cp.CloudPayments();
                        widget.pay(
                            "auth", //  'charge'
                            {
                                //options
                                publicId: response.data.payment_data.publicId,
                                description: response.data.payment_data.description,
                                amount: normalizeAmount(response.data.payment_data.amount - Math.abs(orderAmountDiscountModifier)),
                                currency: response.data.payment_data.currency,
                                invoiceId: response.data.payment_data.invoiceId,
                                accountId: response.data.payment_data.accountId,
                                skin: response.data.payment_data.skin,
                                data: {
                                    "CloudPayments": {
                                        "CustomerReceipt": receipt, //онлайн-чек
                                    }
                                }
                            }, {
                                onSuccess: function(options) {
                                    context.commit(SET_STATUS, { process: MAKE_ORDER, status: true })
                                    context.commit(SET_LOADING, { process: MAKE_ORDER, loading: true })
                                    loader.router.push({ name: 'finish', params: { token: context.getters.token } })
                                },
                                onFail: function(reason, options) {
                                    context.commit(SET_STATUS, { process: MAKE_ORDER, status: false })
                                    context.commit(SET_LOADING, { process: MAKE_ORDER, loading: false })
                                    console.log(reason);
                                },
                                onComplete: function(paymentResult, options) {
                                    if (paymentResult.success === true) {
                                        context.commit(SET_STATUS, { process: MAKE_ORDER, status: true })
                                        context.commit(SET_LOADING, { process: MAKE_ORDER, loading: true })
                                        loader.router.push({ name: 'finish', params: { token: context.getters.token } })
                                        document.querySelector('[id*="cp-scrollable-"]').remove();
                                        document.querySelector('body [type="text/css"]').remove();
                                    }
                                },
                            }
                        );
                    }

                    // WayForPay
                    if (response.data.payment_provider_id === 4) {
                        // eslint-disable-next-line no-undef
                        let wayforpay = new Wayforpay()

                        wayforpay.run(response.data.payment_data,
                            function(response) {
                                // on approved
                                context.commit(SET_STATUS, { process: MAKE_ORDER, status: true })
                                context.commit(SET_LOADING, { process: MAKE_ORDER, loading: true })
                                loader.router.push('finish')
                            },
                            function(response) {
                                // on declined
                                context.commit(SET_STATUS, { process: MAKE_ORDER, status: false })
                                context.commit(SET_LOADING, { process: MAKE_ORDER, loading: false })
                            },
                            function(response) {
                                context.commit(SET_STATUS, { process: MAKE_ORDER, status: true })
                                context.commit(SET_LOADING, { process: MAKE_ORDER, loading: true })
                                loader.router.push('finish')
                                    // on pending or in processing
                            }
                        )
                    }

                }
            } else {

                loader.router.push('finish')
            }
        }).catch(error => {
            if (error.response != undefined) {
                loader.router.push({ name: 'receipt' });

                context.commit(SET_SYSTEM_POPUP, { status: true, text: error.response.data.message });
                context.commit(SET_EXPIRED_PRODUCTS, error.response.data.expired_products);
            }

            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })

        }).finally(() => {
            context.commit(SET_LOADING, { process: MAKE_ORDER, loading: false })
            context.commit(SET_STATUS, { process: MAKE_ORDER, status: false });
        })
    },

    // url: /api/v2/booking/create
    // headers: такие же как и для создания заказа к примеру
    // params:
    // 'date_time' => '2022-10-12 12:50',
    // 'email' => 'pchelintsev.s.a@gmail.com',
    // 'first_name' => 'Sergey',
    // 'phone' => '79006224379',
    // 'qty_devices' => '2',
    // 'comment' => 'asdasd dasdasdasd aasd',
    [MAKE_BOOKING](context, {
        email,
        comment,
        name,
        phone,
        qty_devices,
        date_time,
    }) {

        context.commit(SET_LOADING, { process: MAKE_BOOKING, loading: true })

        return axios({
            method: 'POST',
            url: api.booking.createBooking.url(),
            data: {
                qty_devices: qty_devices !== undefined ? qty_devices : null,
                first_name: name !== undefined ? name : null,
                phone: phone !== undefined ? phone : null,
                email: email !== undefined ? email : null,
                comment: comment !== undefined ? comment : null,
                date_time,
            }
        }).then(response => {
            context.commit(SET_STATUS, { process: MAKE_BOOKING, status: true })
            loader.router.push('finish')
        }).catch(error => {
            if (error.response != undefined) {
                // loader.router.push({ name: 'receipt' });
                context.commit(SET_SYSTEM_POPUP, { status: true, text: error.response.data.message });
            }
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })

        }).finally(() => {
            context.commit(SET_LOADING, { process: MAKE_BOOKING, loading: false })
            context.commit(SET_STATUS, { process: MAKE_BOOKING, status: false });
        })
    },


    [CHECK_IIKO](context, {
        address,
        flat,
        cashback,
        porch,
        email,
        floor,
        domofon,
        comment,
        changing,
        deliveryService,
        payment,
        paymentCustom,
        name,
        phone,
        fullName,
        localAddress,
        fullAddress,
        recipientPhone,
        formCustomFields,
        qty_devices
    }) {
        if (context.getters.loading[CHECK_IIKO] === true) {
            return
        }

        context.commit(SET_LOADING, { process: CHECK_IIKO, loading: true })

        const deliveryTimeObject = {
            ...JSON.parse(JSON.stringify(context.getters.deliveryTimeObject ))
        }

        deliveryTimeObject.time.asap = false

        axios({
            method: 'POST',
            url: api.order.createCheckIiko.url(),
            data: {
                order_id: context.state.order_id,
                time: deliveryTimeObject,
                flat: flat !== undefined ? flat : null,
                address: address !== undefined ? address : null,
                porch: porch !== undefined ? porch : null,
                floor: floor !== undefined ? floor : null,
                domofon: domofon !== undefined ? domofon : null,
                comment: comment !== undefined ? comment : null,
                changing: changing !== undefined ? changing : null,
                delivery_service_id: deliveryService !== undefined ? deliveryService.id : null,
                delivery_service_type_id: deliveryService !== undefined ? deliveryService.type : null,
                qty_devices: qty_devices !== undefined ? qty_devices : null,
                payment: payment !== undefined ? payment : null,
                paymentCustom: paymentCustom !== undefined ? paymentCustom : null,
                name: name !== undefined ? name : null,
                delivery_type: context.getters.outletSettings.delivery_type !== undefined ? context.getters.outletSettings.delivery_type : null,
                cashback: cashback !== undefined ? cashback : null,
                phone: phone !== undefined ? phone : null,
                email: email !== undefined ? email : null,
                basket_comment: context.getters.cookComment !== undefined ? context.getters.cookComment : null,
                fullName: fullName !== undefined ? fullName : null,
                localAddress: localAddress !== undefined ? localAddress : null,
                fullAddress: fullAddress !== undefined ? fullAddress : null,
                recipientPhone: recipientPhone !== undefined ? recipientPhone : null,
                delivery_time_mode: context.getters.deliveryTimeMode !== undefined ? context.getters.deliveryTimeMode : null,
                promocode: context.getters.promocode !== undefined ? context.getters.promocode : null,
                formCustomFields: formCustomFields !== undefined ? formCustomFields : null
            }
        }).then(response => {

            context.commit(SET_STATUS, { process: CHECK_IIKO, status: true })
            if (response.data.success === 1) {
                window.location = context.state.payment_link
            } else {
                new Noty({
                    type: 'error',
                    theme: 'sunset',
                    text: new Vue().text('error') || 'Internal error occurred. Please try again later',
                    timeout: 2000
                }).show()
            }

        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        }).finally(() => {
            context.commit(SET_LOADING, { process: CHECK_IIKO, loading: false })
        })
    }

}

export const mutations = {
    [SET_ORDER_ID](state, data) {
        state.order_id = data
    },
    [SET_PAYMENT_LINK](state, data) {
        state.payment_link = data
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}
